/*
 *
 * ResultPopUp
 *
 * @version 1.0.0
 * @author Marco Civello
 * @since 23-Jan-2025
 */

import ResultPopUp from './ResultPopUpContainer'

export default ResultPopUp
